import { Typography } from 'antd';
import styled from 'styled-components';

export const CParagraph = styled(Typography.Paragraph)<{
  size?: string;
  weight?: string;
  align?: string;
  textTransform?: string;
  color?: string;
  visible: boolean;
}>`
  width: 100%;
  min-height: 22px !important;
  line-height: 22px !important;
  left: 0px !important;
  margin: 0px !important;
  padding-bottom: 0px !important;
  color: ${props => props.theme.colors.text[props.color ?? 'primary']};
  font-size: ${props => props.theme.font.size[props.size ?? 'xs']};
  font-weight: ${props => props.theme.font.weight[props.weight ?? 'bold']};
  text-transform: ${props => props.textTransform ?? 'none'} !important;
  text-align: ${props => props.align ?? 'left'};

  border-radius: 3px;

  cursor: text;

  transition: none;

  ${props =>
    !props.visible &&
    `
  &:hover {
    outline: 4px solid #f1f1f1;
    background: #f1f1f1 !important;
  }
  `}

  .ant-typography-edit {
    color: ${props => props.theme.colors.text.primary} !important;
    font-size: ${props => props.theme.font.size[props.size ?? 'xs']} !important;
    font-weight: ${props =>
      props.theme.font.weight[props.weight ?? 'bold']} !important;
    text-transform: ${props => props.textTransform ?? 'none'} !important;
    text-align: ${props => props.align ?? 'left'};
  }

  .ant-typography-edit {
    display: none !important;
  }

  .ant-input {
    height: 22px;
    min-height: 22px !important;
    line-height: 22px !important;
    padding: 0;
    text-align: ${props => props.align ?? 'left'};
    font-weight: ${props =>
      props.theme.font.weight[props.weight ?? 'bold']} !important;
    font-size: ${props => props.theme.font.size[props.size ?? 'xs']} !important;
    text-transform: ${props => props.textTransform ?? 'none'} !important;

    border: 0;
    border-bottom: 1px solid #d9d9d9;
    transition: none;

    &:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .action {
    display: none;
    transform: translate(0, 2px);
  }

  .ant-typography-edit-content-confirm {
    display: none !important;
  }
`;
